// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uZdgh","tabsBox":"styles_tabsBox__2xwbe","createButton":"styles_createButton__3P4Q4"};